//#region ../base/api/error.ts
var JwApiError = class extends Error {
	name = "JwApiError";
	response;
	parsedMessage;
	constructor(response) {
		let parsedMessage = "An unknown error has occurred.";
		let status;
		if (response?.data && typeof response.data === "object" && "errors" in response.data && Array.isArray(response.data.errors)) {
			parsedMessage = response.data.errors.map((e) => e.description).join("\n");
			status = response.status;
		}
		super((status ? `[${status}] ` : "") + parsedMessage);
		this.response = response;
		this.parsedMessage = parsedMessage;
	}
	toString() {
		return this.parsedMessage;
	}
};
function isJwApiError(e) {
	return e instanceof JwApiError;
}

//#endregion
export { JwApiError, isJwApiError };
//# sourceMappingURL=error.js.map